
import Slider from '@/components/ui/slider.vue';

export default {
  name: 'Cards',

  components: {
    Slider,
  },

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
